import { useAxios } from 'src/hooks/use-axios';

export function useDocumentWithdraw(url: string) {
  return useAxios(
    (axios, signal) =>
      axios.request({
        signal,
        method: 'DELETE',
        url,
      }),
    { neededOnPageLoad: false }
  );
}

export type DocumentWithdrawRequest = ReturnType<typeof useDocumentWithdraw>;
